<script lang="ts">
	import { onMount } from "svelte";
	import { slide } from "svelte/transition";

	export let showNav = true;
	export let paddingTarget = "scroll-collapse-spacing";
	export let paddingHeightTarget: string = "";

	let scrollCollapseSpacingRef: null | HTMLElement = null;

	let lastScrollPosition = 0;
	const scrollThreshold = 0; // Minimum pixels scrolled up to show the nav

	let ref: HTMLElement;

	let initHeight: number = 0;
	let timer: ReturnType<typeof setTimeout>;

	onMount(() => {
		scrollCollapseSpacingRef = document.getElementById(paddingTarget);

		if (paddingHeightTarget) {
			initHeight =
				document.getElementById(paddingHeightTarget)?.getBoundingClientRect()
					.height || 0;
		} else {
			initHeight = ref.getBoundingClientRect().height;
		}

		if (scrollCollapseSpacingRef) {
			scrollCollapseSpacingRef.style.paddingTop = initHeight + "px";
		}
	});
</script>

<svelte:window
	on:scroll={() => {
		if (timer !== null) {
			clearTimeout(timer);
		}
		timer = setTimeout(function () {
			const currentScrollPosition =
				window.scrollY || document.documentElement.scrollTop;

			if (currentScrollPosition < initHeight) {
				showNav = true;
				return;
			}

			if (currentScrollPosition < 100) {
				showNav = true;
				return;
			}

			if (currentScrollPosition > lastScrollPosition) {
				// Scrolling down
				showNav = false;
				// offset.target += (currentScrollPosition - lastScrollPosition) * 2;
			} else if (lastScrollPosition - currentScrollPosition > scrollThreshold) {
				// Scrolling up and meets threshold
				// offset.target = 0;
				showNav = true;
			}

			lastScrollPosition = currentScrollPosition;
			if (scrollCollapseSpacingRef) {
				scrollCollapseSpacingRef.style.paddingTop = initHeight + "px";
			}
		}, 0);
	}}
/>
{#if showNav}
	<div
		transition:slide={{
			duration: 300,
			axis: "y"
		}}
		bind:this={ref}
		class={`${$$props.class} w-full`}
	>
		<slot />
	</div>
{/if}
